<template>
  <router-link
    class="logo"
    :to="{name: 'index'}"
  >
    <v-icon>mdi-bullseye-arrow</v-icon>
    <span class="logo__text">uday.club</span>
  </router-link>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.logo {
  display: flex;
  align-items: center;
  text-decoration: none;

  .v-icon {
    font-size: 50px;
    color: #62708f;
  }
  .logo__text {
    font-size: 30px;
    font-weight: 300;
    margin-left: 10px;
    color: #62708f;
  }
}
</style>